/**
 * IDs = Agent::AVATAR_VARIANTS (Rails).
 */
export const EXECUTOR_AVATAR_VARIANTS = ['orbit', 'deck', 'spire']
export const COORDINATOR_AVATAR_VARIANTS = ['coord_hub', 'coord_supervisor', 'coord_orchestrator']
export const AGENT_AVATAR_VARIANTS = [...EXECUTOR_AVATAR_VARIANTS, ...COORDINATOR_AVATAR_VARIANTS]

export const AGENT_AVATAR_COLORS = [
  { hex: '#6366f1', label: 'Índigo' },
  { hex: '#8b5cf6', label: 'Violeta' },
  { hex: '#a855f7', label: 'Roxo' },
  { hex: '#ec4899', label: 'Rosa' },
  { hex: '#f43f5e', label: 'Coral' },
  { hex: '#f97316', label: 'Laranja' },
  { hex: '#eab308', label: 'Âmbar' },
  { hex: '#22c55e', label: 'Verde' },
  { hex: '#14b8a6', label: 'Turquesa' },
  { hex: '#0ea5e9', label: 'Céu' },
  { hex: '#64748b', label: 'Ardósia' },
  { hex: '#78716c', label: 'Pedra' },
  { hex: '#d1d5db', label: 'Cinza claro' }
]

export const DEFAULT_AGENT_AVATAR_VARIANT = 'orbit'
export const DEFAULT_AGENT_AVATAR_COLOR = '#6366f1'

export function normalizeAgentAvatarVariant(v) {
  const raw = String(v || '').trim()
  return AGENT_AVATAR_VARIANTS.includes(raw) ? raw : DEFAULT_AGENT_AVATAR_VARIANT
}

export function normalizeAgentAvatarColor(c) {
  const hex = String(c || '').toLowerCase()
  const allowed = new Set(AGENT_AVATAR_COLORS.map((x) => x.hex.toLowerCase()))
  return allowed.has(hex) ? hex : DEFAULT_AGENT_AVATAR_COLOR
}
